export default {spreads:{BaseStorableSchema:{}}}